import { Spinner } from "react-bootstrap";

interface Props {
  textColor: string;
  backgroundColor: string;
}

export default function LoadingButton({ textColor, backgroundColor }: Props) {
  return (
    <button
      className="btn btn-rounded btn-sm"
      type="button"
      style={{
        backgroundColor,
        color: textColor,
        cursor: "not-allowed",
      }}
    >
      <div className="text-center">
        <Spinner animation="border" size="sm"></Spinner>
      </div>
    </button>
  );
}
